module.exports = __webpack_public_path__ + "img/s_11.2b3d84a0.png";